import React, { useEffect, useState } from "react";
import LottieLoading from "../lottie/loading/LottieLoading";
export default function NetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  // const dispatch = useDispatch();
  useEffect(() => {
    // Update network status
    const handleStatusChange = () => {
      setIsOnline(navigator.onLine);
      // dispatch(SetNetwokStatus(navigator.onLine));
    };

    // Listen to the online status
    window.addEventListener("online", handleStatusChange);

    // Listen to the offline status
    window.addEventListener("offline", handleStatusChange);

    // Specify how to clean up after this effect for performance improvment
    return () => {
      window.removeEventListener("online", handleStatusChange);
      window.removeEventListener("offline", handleStatusChange);
    };
  }, [isOnline]);

  return (
    <>
      {!isOnline && (
        <div className="w-full bg-gray-200 flex justify-center items-center text-sm sm:text-base text-secondary-900 py-1 h-screen flex-col fixed z-100">
          <div className="my-6 mx-auto w-64">
            <LottieLoading />
          </div>
          <h1 className="text-lg font-semibold text-secondary-600">
            Connect to the internet
          </h1>
          <p>You're offline, Check your connection</p>{" "}
        </div>
      )}
    </>
  );
}
